import { jsx as a, jsxs as d } from "react/jsx-runtime";
import { createContext as L, useContext as I, useCallback as B, forwardRef as r } from "react";
function E(_) {
  var c, e, l = "";
  if (typeof _ == "string" || typeof _ == "number")
    l += _;
  else if (typeof _ == "object")
    if (Array.isArray(_)) {
      var o = _.length;
      for (c = 0; c < o; c++)
        _[c] && (e = E(_[c])) && (l && (l += " "), l += e);
    } else
      for (e in _)
        _[e] && (l && (l += " "), l += e);
  return l;
}
function x() {
  for (var _, c, e = 0, l = "", o = arguments.length; e < o; e++)
    (_ = arguments[e]) && (c = E(_)) && (l && (l += " "), l += c);
  return l;
}
const W = "@gjensidige/core-analytics", Z = "16.0.10", m = "not-set", y = "application_module", k = "event_module", O = {
  [y]: m,
  application_name: m,
  business_area: m,
  customer_segment: m,
  event_source: W,
  event_version: Z
}, q = (_, c, e) => A({ ...c, ..._ }, "link", e), z = L({
  options: { ...O }
});
let $ = 0;
function A(_ = {}, c, e) {
  var l;
  const o = (l = window.utag) == null ? void 0 : l[c].bind(window.utag);
  o ? e ? o(C(_), e) : o(C(_)) : $ < 10 ? setTimeout(() => A(_, c), 100, $++) : console.error(`window.utag.${c} not found `, _);
}
function C(_) {
  const c = { ...O };
  return Object.entries(_).forEach(([e, l]) => {
    const o = e === "eventLabel" || e === "eventStatus", s = e.replace(/[A-Z]/g, "_$&").toLowerCase();
    o && l && (l = `${l}`.toLowerCase().split(" ").join("-")), c[s] = l;
  }), {
    ...c,
    [k]: c[k] || c[y],
    page_pathname: c.page_pathname || J(c),
    measure_source: c.event_source,
    measure_version: c.event_version
  };
}
function J(_) {
  return `${window.location.pathname.replace(/\/$/, "")}/${_.application_name}/${_[y]}/${_.scenario_name}/${_.scenario_step}`.replace(/\/(undefined|null|not-set)/g, "").replace("/Din+side/", "/Din-side/");
}
const K = "@gjensidige/builders-components", Q = "1.2.2";
function X(_) {
  const { options: c } = I(z);
  return B(
    (e) => {
      _ && q(
        {
          eventVersion: Q,
          eventSource: K,
          eventLabel: "",
          ...e,
          ..._ === !0 ? {} : _
        },
        c
      );
    },
    [_, c]
  );
}
function Y(_) {
  return _ instanceof HTMLElement ? (_.innerText || _.textContent || _.getAttribute("aria-label") || "").replace(/\n/g, " ").trim() : "";
}
const __ = (_) => /* @__PURE__ */ a("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-hidden": !0, focusable: !1, ..._, children: /* @__PURE__ */ a("path", { d: "M11 13L22 2M22 2H14M22 2V10M9 2H2V22H22V15", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), c_ = "_flex_1cpbh_7", l_ = "_fill_1cpbh_13", e_ = "_inline_1cpbh_24", o_ = "_column_1cpbh_27", n = {
  flex: c_,
  fill: l_,
  inline: e_,
  column: o_,
  "column-reverse": "_column-reverse_1cpbh_30",
  "row-reverse": "_row-reverse_1cpbh_33",
  "wrap-reverse": "_wrap-reverse_1cpbh_36",
  "wrap-nowrap": "_wrap-nowrap_1cpbh_39",
  "align-start": "_align-start_1cpbh_45",
  "align-center": "_align-center_1cpbh_48",
  "align-end": "_align-end_1cpbh_51",
  "align-baseline": "_align-baseline_1cpbh_54",
  "align-stretch": "_align-stretch_1cpbh_57",
  "align-content-start": "_align-content-start_1cpbh_60",
  "align-content-center": "_align-content-center_1cpbh_63",
  "align-content-end": "_align-content-end_1cpbh_66",
  "align-content-stretch": "_align-content-stretch_1cpbh_69",
  "align-content-baseline": "_align-content-baseline_1cpbh_72",
  "align-content-space-around": "_align-content-space-around_1cpbh_75",
  "align-content-space-between": "_align-content-space-between_1cpbh_78",
  "align-content-space-evenly": "_align-content-space-evenly_1cpbh_81",
  "justify-start": "_justify-start_1cpbh_84",
  "justify-center": "_justify-center_1cpbh_87",
  "justify-end": "_justify-end_1cpbh_90",
  "justify-space-around": "_justify-space-around_1cpbh_93",
  "justify-space-between": "_justify-space-between_1cpbh_96",
  "justify-space-evenly": "_justify-space-evenly_1cpbh_99",
  "center-md": "_center-md_1cpbh_102",
  "center-lg": "_center-lg_1cpbh_106",
  "center-xl": "_center-xl_1cpbh_107",
  "center-xxl": "_center-xxl_1cpbh_108",
  "xs-10.2": "_xs-10.2_1cpbh_131",
  "xs-2.1": "_xs-2.1_1cpbh_132",
  "xs-3.9": "_xs-3.9_1cpbh_139",
  "xs-9.3": "_xs-9.3_1cpbh_140",
  "xs-4.8": "_xs-4.8_1cpbh_143",
  "xs-8.4": "_xs-8.4_1cpbh_144",
  "xs-5.7": "_xs-5.7_1cpbh_147",
  "xs-7.5": "_xs-7.5_1cpbh_148",
  "xs-1": "_xs-1_1cpbh_131",
  "xs-2": "_xs-2_1cpbh_132",
  "xs-3": "_xs-3_1cpbh_139",
  "xs-4": "_xs-4_1cpbh_143",
  "xs-6": "_xs-6_1cpbh_175",
  "xs-row-gap-none": "_xs-row-gap-none_1cpbh_178",
  "xs-col-gap-none": "_xs-col-gap-none_1cpbh_181",
  "xs-row-gap-xs": "_xs-row-gap-xs_1cpbh_187",
  "xs-col-gap-xs": "_xs-col-gap-xs_1cpbh_190",
  "xs-row-gap-sm": "_xs-row-gap-sm_1cpbh_196",
  "xs-col-gap-sm": "_xs-col-gap-sm_1cpbh_199",
  "xs-row-gap-md": "_xs-row-gap-md_1cpbh_205",
  "xs-col-gap-md": "_xs-col-gap-md_1cpbh_208",
  "xs-row-gap-lg": "_xs-row-gap-lg_1cpbh_214",
  "xs-col-gap-lg": "_xs-col-gap-lg_1cpbh_217",
  "xs-row-gap-xl": "_xs-row-gap-xl_1cpbh_223",
  "xs-col-gap-xl": "_xs-col-gap-xl_1cpbh_226",
  "sm-2.1": "_sm-2.1_1cpbh_233",
  "sm-10.2": "_sm-10.2_1cpbh_234",
  "sm-3.9": "_sm-3.9_1cpbh_241",
  "sm-9.3": "_sm-9.3_1cpbh_242",
  "sm-4.8": "_sm-4.8_1cpbh_249",
  "sm-8.4": "_sm-8.4_1cpbh_250",
  "sm-5.7": "_sm-5.7_1cpbh_257",
  "sm-7.5": "_sm-7.5_1cpbh_258",
  "sm-1": "_sm-1_1cpbh_234",
  "sm-2": "_sm-2_1cpbh_233",
  "sm-3": "_sm-3_1cpbh_241",
  "sm-4": "_sm-4_1cpbh_249",
  "sm-6": "_sm-6_1cpbh_277",
  "sm-row-gap-none": "_sm-row-gap-none_1cpbh_280",
  "sm-col-gap-none": "_sm-col-gap-none_1cpbh_283",
  "sm-row-gap-xs": "_sm-row-gap-xs_1cpbh_289",
  "sm-col-gap-xs": "_sm-col-gap-xs_1cpbh_292",
  "sm-row-gap-sm": "_sm-row-gap-sm_1cpbh_298",
  "sm-col-gap-sm": "_sm-col-gap-sm_1cpbh_301",
  "sm-row-gap-md": "_sm-row-gap-md_1cpbh_307",
  "sm-col-gap-md": "_sm-col-gap-md_1cpbh_310",
  "sm-row-gap-lg": "_sm-row-gap-lg_1cpbh_316",
  "sm-col-gap-lg": "_sm-col-gap-lg_1cpbh_319",
  "sm-row-gap-xl": "_sm-row-gap-xl_1cpbh_325",
  "sm-col-gap-xl": "_sm-col-gap-xl_1cpbh_328",
  "md-2.1": "_md-2.1_1cpbh_336",
  "md-10.2": "_md-10.2_1cpbh_337",
  "md-3.9": "_md-3.9_1cpbh_344",
  "md-9.3": "_md-9.3_1cpbh_345",
  "md-4.8": "_md-4.8_1cpbh_352",
  "md-8.4": "_md-8.4_1cpbh_353",
  "md-5.7": "_md-5.7_1cpbh_360",
  "md-7.5": "_md-7.5_1cpbh_361",
  "md-1": "_md-1_1cpbh_337",
  "md-2": "_md-2_1cpbh_336",
  "md-3": "_md-3_1cpbh_344",
  "md-4": "_md-4_1cpbh_352",
  "md-6": "_md-6_1cpbh_380",
  "md-row-gap-none": "_md-row-gap-none_1cpbh_383",
  "md-col-gap-none": "_md-col-gap-none_1cpbh_386",
  "md-row-gap-xs": "_md-row-gap-xs_1cpbh_392",
  "md-col-gap-xs": "_md-col-gap-xs_1cpbh_395",
  "md-row-gap-sm": "_md-row-gap-sm_1cpbh_401",
  "md-col-gap-sm": "_md-col-gap-sm_1cpbh_404",
  "md-row-gap-md": "_md-row-gap-md_1cpbh_410",
  "md-col-gap-md": "_md-col-gap-md_1cpbh_413",
  "md-row-gap-lg": "_md-row-gap-lg_1cpbh_419",
  "md-col-gap-lg": "_md-col-gap-lg_1cpbh_422",
  "md-row-gap-xl": "_md-row-gap-xl_1cpbh_428",
  "md-col-gap-xl": "_md-col-gap-xl_1cpbh_431",
  "lg-2.1": "_lg-2.1_1cpbh_439",
  "lg-10.2": "_lg-10.2_1cpbh_440",
  "lg-3.9": "_lg-3.9_1cpbh_447",
  "lg-9.3": "_lg-9.3_1cpbh_448",
  "lg-4.8": "_lg-4.8_1cpbh_455",
  "lg-8.4": "_lg-8.4_1cpbh_456",
  "lg-5.7": "_lg-5.7_1cpbh_463",
  "lg-7.5": "_lg-7.5_1cpbh_464",
  "lg-1": "_lg-1_1cpbh_440",
  "lg-2": "_lg-2_1cpbh_439",
  "lg-3": "_lg-3_1cpbh_447",
  "lg-4": "_lg-4_1cpbh_455",
  "lg-6": "_lg-6_1cpbh_483",
  "lg-row-gap-none": "_lg-row-gap-none_1cpbh_486",
  "lg-col-gap-none": "_lg-col-gap-none_1cpbh_489",
  "lg-row-gap-xs": "_lg-row-gap-xs_1cpbh_495",
  "lg-col-gap-xs": "_lg-col-gap-xs_1cpbh_498",
  "lg-row-gap-sm": "_lg-row-gap-sm_1cpbh_504",
  "lg-col-gap-sm": "_lg-col-gap-sm_1cpbh_507",
  "lg-row-gap-md": "_lg-row-gap-md_1cpbh_513",
  "lg-col-gap-md": "_lg-col-gap-md_1cpbh_516",
  "lg-row-gap-lg": "_lg-row-gap-lg_1cpbh_522",
  "lg-col-gap-lg": "_lg-col-gap-lg_1cpbh_525",
  "lg-row-gap-xl": "_lg-row-gap-xl_1cpbh_531",
  "lg-col-gap-xl": "_lg-col-gap-xl_1cpbh_534",
  "xl-2.1": "_xl-2.1_1cpbh_542",
  "xl-10.2": "_xl-10.2_1cpbh_543",
  "xl-3.9": "_xl-3.9_1cpbh_550",
  "xl-9.3": "_xl-9.3_1cpbh_551",
  "xl-4.8": "_xl-4.8_1cpbh_558",
  "xl-8.4": "_xl-8.4_1cpbh_559",
  "xl-5.7": "_xl-5.7_1cpbh_566",
  "xl-7.5": "_xl-7.5_1cpbh_567",
  "xl-1": "_xl-1_1cpbh_543",
  "xl-2": "_xl-2_1cpbh_542",
  "xl-3": "_xl-3_1cpbh_550",
  "xl-4": "_xl-4_1cpbh_558",
  "xl-6": "_xl-6_1cpbh_586",
  "xl-row-gap-none": "_xl-row-gap-none_1cpbh_589",
  "xl-col-gap-none": "_xl-col-gap-none_1cpbh_592",
  "xl-row-gap-xs": "_xl-row-gap-xs_1cpbh_598",
  "xl-col-gap-xs": "_xl-col-gap-xs_1cpbh_601",
  "xl-row-gap-sm": "_xl-row-gap-sm_1cpbh_607",
  "xl-col-gap-sm": "_xl-col-gap-sm_1cpbh_610",
  "xl-row-gap-md": "_xl-row-gap-md_1cpbh_616",
  "xl-col-gap-md": "_xl-col-gap-md_1cpbh_619",
  "xl-row-gap-lg": "_xl-row-gap-lg_1cpbh_625",
  "xl-col-gap-lg": "_xl-col-gap-lg_1cpbh_628",
  "xl-row-gap-xl": "_xl-row-gap-xl_1cpbh_634",
  "xl-col-gap-xl": "_xl-col-gap-xl_1cpbh_637",
  "xxl-2.1": "_xxl-2.1_1cpbh_645",
  "xxl-10.2": "_xxl-10.2_1cpbh_646",
  "xxl-3.9": "_xxl-3.9_1cpbh_653",
  "xxl-9.3": "_xxl-9.3_1cpbh_654",
  "xxl-4.8": "_xxl-4.8_1cpbh_661",
  "xxl-8.4": "_xxl-8.4_1cpbh_662",
  "xxl-5.7": "_xxl-5.7_1cpbh_669",
  "xxl-7.5": "_xxl-7.5_1cpbh_670",
  "xxl-1": "_xxl-1_1cpbh_646",
  "xxl-2": "_xxl-2_1cpbh_645",
  "xxl-3": "_xxl-3_1cpbh_653",
  "xxl-4": "_xxl-4_1cpbh_661",
  "xxl-6": "_xxl-6_1cpbh_689",
  "xxl-12": "_xxl-12_1cpbh_692",
  "xxl-row-gap-none": "_xxl-row-gap-none_1cpbh_695",
  "xxl-col-gap-none": "_xxl-col-gap-none_1cpbh_698",
  "xxl-row-gap-xs": "_xxl-row-gap-xs_1cpbh_704",
  "xxl-col-gap-xs": "_xxl-col-gap-xs_1cpbh_707",
  "xxl-row-gap-sm": "_xxl-row-gap-sm_1cpbh_713",
  "xxl-col-gap-sm": "_xxl-col-gap-sm_1cpbh_716",
  "xxl-row-gap-md": "_xxl-row-gap-md_1cpbh_722",
  "xxl-col-gap-md": "_xxl-col-gap-md_1cpbh_725",
  "xxl-row-gap-lg": "_xxl-row-gap-lg_1cpbh_731",
  "xxl-col-gap-lg": "_xxl-col-gap-lg_1cpbh_734",
  "xxl-row-gap-xl": "_xxl-row-gap-xl_1cpbh_740",
  "xxl-col-gap-xl": "_xxl-col-gap-xl_1cpbh_743"
}, M = r(function({
  align: _,
  alignContent: c,
  as: e,
  center: l = !1,
  className: o,
  direction: s = "row",
  fill: p,
  gap: t = "md",
  inline: i,
  justify: w,
  layout: u = {},
  wrap: h = "wrap",
  ...H
}, U) {
  const V = e || "div", D = N(t).flatMap(([b, f]) => {
    const [j, R = j] = f.trim().split(" ");
    return [
      n[`${b}-row-gap-${j}`],
      n[`${b}-col-gap-${R}`]
    ];
  }), P = N(u).map(
    ([b, f]) => n[`${b}-${Number(f)}`]
    // Convert to number to ensure 2.10 is converted to 2.1
  );
  return /* @__PURE__ */ a(
    V,
    {
      ...H,
      className: x(
        n.flex,
        !p || n.fill,
        !i || n.inline,
        n[s],
        n[`align-${_}`],
        n[`align-content-${c}`],
        n[`center-${l === !0 ? "xxl" : l}`],
        n[`justify-${w}`],
        n[`wrap-${h}`],
        ...D,
        ...P,
        o
      ),
      ref: U
    }
  );
}), N = (_) => Object.entries(typeof _ == "object" ? _ : { xs: _ }), p_ = "_link_4xee8_1", n_ = "_external_4xee8_19", F = {
  link: p_,
  external: n_
}, s_ = r(function({
  as: _,
  children: c,
  className: e,
  icon: l = "auto",
  onClick: o,
  tracking: s = !0,
  ...p
}, t) {
  const i = _ || "a", w = X(s), u = (h) => {
    w({
      eventCategory: "link",
      eventAction: "click",
      eventLabel: Y(h.currentTarget)
    }), o == null || o(h);
  };
  return p.target === "_blank" && Object.assign(p, { rel: "noreferrer noopener" }), /* @__PURE__ */ d(
    i,
    {
      className: x(F.link, e),
      onClick: u,
      ref: t,
      ...p,
      children: [
        c,
        p.target === "_blank" && l && /* @__PURE__ */ a(__, { className: F.external })
      ]
    }
  );
}), a_ = {
  copyright: "Copyright © Gjensidige",
  editCookies: "Ret cookieindstillinger"
}, S = {
  copyright: "Copyright © Gjensidige",
  editCookies: "Edit cookie consent"
}, t_ = {
  copyright: "Opphavsrett © Gjensidige",
  editCookies: "Endre cookieinnstillinger"
}, g_ = {
  copyright: "© 2023 Gjensidige Försäkring",
  editCookies: "Ändra cookieinställningar"
}, v = { da: a_, en: S, nb: t_, sv: g_ }, T = L(S), r_ = "_footer_1hj56_2", x_ = "_nav_1hj56_30", i_ = "_social_1hj56_34", h_ = "_extras_1hj56_73", b_ = "_extrasItems_1hj56_97", m_ = "_copyright_1hj56_102", g = {
  footer: r_,
  nav: x_,
  social: i_,
  extras: h_,
  extrasItems: b_,
  copyright: m_
}, G = r(
  function({ label: c, className: e, icon: l, tracking: o = !0, ...s }, p) {
    const t = Object.assign({ eventCategory: "footer-item" }, o), i = x(g.item, e);
    return /* @__PURE__ */ d(
      s_,
      {
        ...s,
        className: i,
        icon: !l,
        ref: p,
        tracking: o && t,
        children: [
          l,
          c
        ]
      }
    );
  }
), d_ = r(
  function({ children: c, className: e, ...l }, o) {
    const { editCookies: s, copyright: p } = I(T), t = x(g.extras, e);
    return /* @__PURE__ */ d(M, { layout: "9.3", ...l, className: t, ref: o, children: [
      /* @__PURE__ */ d("div", { className: g.extrasItems, children: [
        /* @__PURE__ */ a(
          G,
          {
            label: s,
            href: "#cookie:settings",
            onClick: () => {
              "UC_UI" in window && UC_UI.showSecondLayer();
            }
          }
        ),
        c
      ] }),
      /* @__PURE__ */ a("div", { className: g.copyright, children: p })
    ] });
  }
), w_ = r(
  function({ className: c, ...e }, l) {
    const o = x(g.nav, c);
    return /* @__PURE__ */ a("div", { ...e, className: o, ref: l });
  }
), u_ = r(
  function({ className: c, ...e }, l) {
    const o = x(g.social, c);
    return /* @__PURE__ */ a("div", { ...e, className: o, ref: l });
  }
), f_ = r(function({ className: c, language: e, ...l }, o) {
  const s = x(g.footer, c);
  let p = v[e];
  return p || (p = v.en, console.warn(
    `core-footer could not start with language "${e}"
      - Please use one of: "${Object.keys(v).join('", "')}"
      - Fallback to english enabled`
  )), /* @__PURE__ */ a(T.Provider, { value: p, children: /* @__PURE__ */ a(
    M,
    {
      as: "footer",
      gap: "xl md",
      center: !0,
      layout: { xs: 1, sm: 2, lg: 3, xl: 4 },
      className: s,
      ref: o,
      ...l
    }
  ) });
}), j_ = Object.assign(f_, {
  Extras: d_,
  Item: G,
  Nav: w_,
  Social: u_
});
export {
  j_ as Footer,
  f_ as FooterComp
};
//# sourceMappingURL=footer.js.map
